exports.default = {
  'account_settings': '賬號設置',
  'nickname': '暱稱',
  'nickname_placeholder': '請輸入暱稱',
  'add_avatar': '修改頭像',
  'email_address': '郵箱地址',
  'change_email': '更改郵箱',
  'device_management': '設備管理',
  'device_tip': '退出其他設備即可，此設備除外',
  'logout_all_devices': '從所有設備退出',
  'device_name': '設備名稱',
  'current_device': '此設備',
  'last_active_time': '上次活躍時間',
  'now': '現在',
  'location': '位置',
  'logout': '退出',
  'delete_my_account': '刪除我的賬號',
  'delete_account_tip': '永久刪除賬號並刪除所有工作空間的訪問權限',
  'crop_image': '剪切圖片',
  'need_crop_image': '是否需要剪切圖片？',
  'crop': '剪切',
  'upload_without_crop': '不剪切直接上傳',
  'upload_image': '上傳圖片',
  'cancel': '取 消',
  'confirm': '確 定',
  'change_email_title': '更改郵箱',
  'no_email_tip': '您還未綁定郵箱，請設置您的郵箱地址。',
  'current_email_is': '您當前的郵件地址是：',
  'will_send_code': ',我們將向此電子郵件地址發送臨時驗證碼。',
  'verification_completed': '已完成驗證',
  'code_sent': '我們已向此電子郵件地址發送臨時驗證碼。',
  'enter_verification_code': '請輸入驗證碼',
  'retry_later': '{newEmailTimer}s後重試',
  'resend': '重新發送',
  'enter_new_email': '請輸入新的電子郵件地址，我們將向你發送驗證碼',
  'enter_new_email_placeholder': '請輸入新的郵箱地址',
  'verification_tip': '我們剛剛向你的郵箱 {email} 發送了一個臨時驗證碼',
  'enter_new_email_code': '請輸入新郵箱驗證碼',
  'send_code': '發送驗證碼',
  'verify': '驗證',
  'bind_email': '綁定郵件地址',
  'change_email_action': '更改郵件地址',
  'delete_account': '刪除賬號',
  'delete_warning': '警告：該操作無法撤銷，刪除後，您的賬號數據都會被刪除，並退出其他團隊。',
  'confirm_by_email': '請輸入您的郵箱確認刪除：',
  'confirm_by_phone': '請輸入您的手機號確認刪除：',
  'enter_email_confirm': '請輸入郵箱確認',
  'enter_phone_confirm': '請輸入手機號確認',
  'confirm_delete_account': '刪除賬號',
  'nickname_empty': '暱稱不能為空',
  'save_success': '保存成功！',
  'image_type_error': '圖片類型必須是：gif,jpeg,jpg,png,bmp中的一種',
  'email_required': '請輸入新郵箱地址',
  'email_invalid': '請輸入有效的郵箱地址',
  'email_duplicate': '新郵箱不能與當前郵箱相同',
  'code_required': '請輸入驗證碼',
  'token_invalid': '驗證令牌已失效，請重新開始',
  'email_bind_success': '郵箱綁定成功！請重新登錄',
  'email_update_success': '郵箱更新成功！請重新登錄',
  'logout_success': '已退出所有其他設備',
  'operation_failed': '操作失敗',
  'logout_current_device': '正在退出當前設備...',
  'logout_device_success': '已成功退出設備',
  'logout_failed': '退出失敗',
  'email_incorrect': '郵箱輸入不正確，無法刪除賬號',
  'phone_incorrect': '手機號輸入不正確，無法刪除賬號',
  'identity_verification': '無法驗證您的身份，請先綁定郵箱或手機號',
  'account_deleted': '賬號已刪除',
  'delete_account_failed': '刪除賬號失敗',
  'get_device_list_failed': '獲取設備列表失敗',
  'account_center': '賬號中心',
  'preferences': '偏好設置',
  'subscription_management': '訂閱管理',
  'bill': '賬單',
  'consumption_records': '消費記錄',
  'no_consumption_records': '暫無積分消費記錄',
  'points_details': '積分明細',
  'points_event': '積分事件',
  'occurred_at': '發生時間',
  'points_change': '積分變化',
  'points_balance': '剩餘積分',
  'loading_more': '正在載入更多...',
  'no_more_records': '沒有更多記錄',
  'points_earned': '獲取積分',
  'points_expired': '積分過期',
  'points_adjusted': '積分調整',
  'points_consumption': '積分消費',
  'agent_task': 'Agent任務',
  'expand_details': '展開明細',
  'collapse_details': '收起明細',
  'refresh_records': '重新整理記錄',
  'video_generation': '影片生成',
  'video_generation_model': '影片生成 · {model}',
  'video_points_reserved': '已預佔 {points} 積分，未扣費',
  'video_points_committed': '預佔已轉扣',
  'video_points_released': '預佔已釋放',
  'video_points_group_held': '目前預佔 {points} 積分',
  'video_points_provisional': '按預估暫扣',
  'video_points_refund': '退還差額',
  'video_points_supplemental': '補扣差額',
  'video_points_adjustment': '積分調整',
  'video_points_settled': '已結算',
  'date': '日期',
  'plan_name': '方案名稱',
  'unpaid': '（未完成支付）',
  'amount': '金額',
  'invoice': '發票',
  'download_pdf': '下載PDF',
  'view_receipt': '查看收據',
  'downloading': '正在下載中......',
  'loading_bill_failed': '加載賬單失敗',
  'invoice_download': '下載發票',
  'invoice_regular_tip': '（此頁面為普通發票開立入口）',
  'invoice_amount': '開票金額',
  'invoice_payment_time': '付款時間',
  'invoice_subscription_content': '訂閱內容',
  'invoice_type': '發票類型',
  'invoice_type_regular': '數位化電子普通發票',
  'invoice_taxpayer_type': '單位類型',
  'invoice_taxpayer_enterprise': '企業',
  'invoice_taxpayer_personal': '個人',
  'invoice_status': '開票狀態',
  'invoice_rejection_reason': '駁回原因',
  'invoice_title': '發票抬頭',
  'invoice_enterprise_title_placeholder': '請輸入企業單位名稱',
  'invoice_personal_title_placeholder': '請輸入個人姓名',
  'invoice_tax_no': '單位稅號',
  'invoice_tax_no_placeholder': '請輸入企業單位稅號或社會信用代碼',
  'invoice_email': '聯絡信箱',
  'invoice_email_placeholder': '請輸入接收發票的聯絡信箱',
  'invoice_registered_address': '註冊地址',
  'invoice_contact_address': '聯絡地址',
  'invoice_registered_address_placeholder': '請輸入企業註冊地址',
  'invoice_contact_address_placeholder': '請輸入聯絡地址（選填）',
  'invoice_registered_phone': '註冊電話',
  'invoice_contact_phone': '聯絡電話',
  'invoice_registered_phone_placeholder': '請輸入企業註冊電話',
  'invoice_contact_phone_placeholder': '請輸入聯絡電話（選填）',
  'invoice_bank': '開戶銀行',
  'invoice_bank_placeholder': '請輸入開戶銀行（選填）',
  'invoice_bank_account': '開戶帳號',
  'invoice_bank_account_placeholder': '請輸入銀行帳號（選填）',
  'invoice_remark': '發票備註',
  'invoice_remark_placeholder': '請輸入發票備註（選填）',
  'invoice_privacy': '上述開票資訊僅用於為您提供開票服務，我們承諾將依相關法律法規妥善處理您的個人資料。',
  'invoice_resubmit': '重新提交',
  'invoice_submit': '提交資訊',
  'invoice_reapply': '重新申請開票',
  'invoice_apply': '申請開票',
  'invoice_details': '開票申請詳情',
  'invoice_rejection_fallback': '請依駁回提示修改後重新提交',
  'invoice_status_processing': '開票中',
  'invoice_status_issued': '已開票',
  'invoice_status_rejected': '已駁回',
  'invoice_status_cancelled': '已取消',
  'invoice_title_email_required': '請填寫發票抬頭及聯絡信箱',
  'invoice_phone_invalid': '請輸入正確的聯絡電話',
  'invoice_tax_no_required': '企業抬頭必須填寫單位稅號',
  'invoice_tax_no_invalid': '單位稅號須為15位數字或18位數字／大寫字母',
  'invoice_submitted': '開票申請已提交',
  'important_info': '重要信息',
  'membership_expiry': '關閉自動續訂後，您的會員資格將會在{endTime}到期。到期後，您將失去以下功能:',
  'special_offer': '特別優惠',
  'discount_info': '繼續訂閱，能享受下一年度{discount_percent}%的折扣優惠! 折扣價{price} (原價{original_price})',
  'continue_subscription': '繼續訂閱並享受折扣',
  'reason_prompt': '請告訴我們您選擇關閉自動續訂的原因：',
  'reason_price': '價格太高使用頻率不高',
  'reason_features': '功能不符合需求',
  'reason_alternative': '轉用其他產品',
  'reason_other': '其他原因',
  'enter_specific_reason': '請輸入具體原因',
  'keep_auto_renewal': '保持自動續訂',
  'confirm_cancel_renewal': '確認關閉自動續訂',
  'close_subscription_failed': '關閉訂閱失敗',
  'return': '返回',
  'modify_payment': '修改支付方式',
  'add_new_payment': '添加新的支付方式',
  'payment_update_tip': '更新您的卡信息，確保訂閱可以順利續期。更新不會立即產生任何費用。',
  'credit_debit_card': '信用卡/借記卡',
  'card_number': '卡號',
  'cardholder_name': '持卡人姓名',
  'enter_cardholder_name': '請輸入持卡人姓名',
  'expiration_date': '有效期',
  'security_code': '安全碼',
  'payment_security_warning': '您的支付信息安全加密處理，更新卡信息不會立即產生費用，僅在下次計費日使用。',
  'save_payment_method': '保存支付方式',
  'stripe_init_failed': 'Stripe初始化失敗',
  'payment_component_init_failed': '初始化支付組件失敗: ',
  'unknown_error': '未知錯誤',
  'get_payment_config_failed': '獲取支付配置失敗',
  'get_payment_key_failed': '獲取支付密鑰失敗',
  'enter_cardholder_name_prompt': '請輸入持卡人姓名',
  'enter_valid_card_number': '請輸入有效的卡號',
  'enter_valid_expiry': '請輸入有效的卡片有效期',
  'enter_valid_cvc': '請輸入有效的安全碼',
  'create_payment_config_failed': '創建支付配置失敗',
  'payment_method_update_success': '支付方式更新成功',
  'payment_method_update_failed': '支付方式更新失敗，請稍後再試',
  'payment_success': '支付成功',
  'thank_you': '感謝您的購買！',
  'upgrade_success': '您已成功升級至{verName}',
  'privilege_activated': '{verName}特權已激活',
  'try_now': '立即體驗',
  'choose_plan': '選擇套餐方案',
  'plan_description': '選擇適合您的套餐，隨時可以升級或降級',
  'yearly': '年付',
  'monthly': '月付',
  'save_percent_planbuy': '省{currentDiscount}%',
  'most_popular': '最受歡迎',
  'recommended': '推薦',
  'price_period_year': '/年',
  'price_period_month': '/月',
  'selected': '已選擇',
  'select_plan': '選擇{plan}',
  'purchase_title': '選擇你的會員方案',
  'purchase_subtitle': '把更多時間留給創作，權益即時生效。',
  'purchase_account_fallback': '會員賬號',
  'membership_expires_on': '會員有效期至 {expiryDate}',
  'purchase_free_member': '免費版',
  'purchase_paid_member': '付費會員',
  'purchase_domestic': '中國大陸版',
  'purchase_international': '國際版',
  'purchase_domestic_note': '僅支援單次購買，微信或支付寶掃碼支付',
  'purchase_international_note': '支援連續包月與連續包年，隨時可取消',
  'purchase_billing_label': '選擇購買週期',
  'purchase_version_label': '選擇會員版本',
  'purchase_period_hint': '按週期選擇最適合你的價格',
  'purchase_benefits_kicker': '會員權益',
  'purchase_period_month': '月付',
  'purchase_period_quarter': '季付',
  'purchase_period_half_year': '半年付',
  'purchase_period_year': '年付',
  'purchase_period_two_year': '兩年付',
  'purchase_choose_plan': '選擇適合你的方案',
  'purchase_previous_plan': '上一組方案',
  'purchase_next_plan': '下一組方案',
  'purchase_single_year': '單次購買 · 包年',
  'purchase_single_month': '單次購買 · 包月',
  'purchase_yearly': '連續包年',
  'purchase_monthly': '連續包月',
  'purchase_save_badge': '省更多',
  'purchase_monthly_equivalent': '折合每月',
  'purchase_one_time': '單次購買，到期後不會自動續費',
  'purchase_auto_renew': '自動續訂，可隨時取消',
  'purchase_domestic_footnote': '支付成功後權益即時到帳，訂單可在賬單中查看。',
  'purchase_international_footnote': '安全支付由 Stripe 提供，續訂設定可在賬號中心管理。',
  'purchase_selected_plan': '當前選擇',
  'purchase_owner_only': '僅團隊擁有者可管理訂閱，您仍可查看團隊方案和點數。',
  'purchase_quote_loading': '正在計算訂閱金額…',
  'purchase_quote_failed': '應付金額計算失敗，請重試後再訂閱。',
  'purchase_quote_retry': '重新計算',
  'purchase_plan_price': '方案價格',
  'purchase_credit': '原付費方案折抵',
  'purchase_quote_note': '折抵僅用於首個計費週期，下單時重新計算實際金額；後續續訂按方案正常價格扣款。',
  'purchase_select_plan_hint': '請選擇一個方案',
  'purchase_pay_now': '立即購買',
  'purchase_select': '選擇方案',
  'purchase_payment_step': '02 · 支付',
  'purchase_scan_title': '掃碼完成支付',
  'purchase_payable': '應付金額',
  'purchase_scan_description': '請選擇微信或支付寶完成支付，支付完成後頁面會自動更新。',
  'purchase_payment_method': '支付方式',
  'wechat': '微信支付',
  'purchase_agreement': '支付即表示你同意《會員服務協議》和《隱私政策》',
  'purchase_refresh': '刷新二維碼',
  'purchase_payment_done': '我已完成支付',
  'purchase_qr_refreshed': '二維碼已刷新',
  'purchase_self_invoice': '自助開票',
  'purchase_invoice_help': '購買後可前往賬號中心-賬單記錄內自助開具發票。',
  'purchase_payment_channels_failed': '可用支付方式加載失敗',
  'purchase_no_payment_channel': '當前暫無可用的支付方式，請稍後重試',
  'purchase_no_plan': '暫無可購買的會員方案',
  'purchase_no_matching_plan': '暫時沒有符合您的方案',
  'purchase_qr_loading': '正在生成支付二維碼',
  'purchase_payment_pending': '暫未查詢到支付結果，請完成支付後重試',
  'purchase_fuel_packages': '購買加油包',
  'purchase_fuel_packages_note': '加油包積分單獨生效',
  'purchase_buy_now': '立即購買',
  'purchase_renew_now': '立即續費',
  'purchase_upgrade_now': '立即升級',
  'purchase_subscribe_now': '立即訂閱',
  'purchase_no_fuel_packages': '暫無可購買的加油包',
  'proceed_to_payment': '前往支付',
  'repay': '重新支付',
  'unfinished_payment_tips': '支付尚未完成，請點擊“重新支付”繼續操作。如需幫助，請聯繫客服。',
  'select_plan_prompt': '請選擇一個套餐方案',
  'processing_payment': '正在處理支付...',
  'get_plan_id_failed': '獲取方案ID失敗',
  'create_payment_session_failed': '創建支付會話失敗',
  'payment_error': '支付過程中發生錯誤',
  'payment_status_timeout': '支付狀態查詢超時',
  'order_cancelled': '訂單已取消',
  'query_order_failed': '查詢訂單信息失敗',
  'appearance': '外觀',
  'theme_customization': '自定義系統主題色',
  'language': '語言',
  'change_language': '更改用戶界面語言',
  'config_load_failed': '配置加載失敗',
  'user_settings_load_failed': '用戶設置加載失敗',
  'save_failed': '保存失敗',
  'free_desc': '免費版提供基礎功能體驗，升級到付費版可解鎖更多高級功能和更高的使用限額。',
  'upgrade': '升級',
  'buy_points': '增購積分',
  'points_usage': '積分使用量',
  'storage_usage': '存儲使用量',
  'points_quota_tip': '{points_quota_used_numerical}/{points_quota_total_numerical}積分',
  'storage_quota_tip': '共計{storage_quota_total_numerical}GB，剩餘{storage_quota_surplus_numerical}GB',
  'all_plans': '所有方案',
  'current_tag': '當前方案',
  'current_plan': '當前方案',
  'save_percent': '省{currentPriceInfo}%',
  'valid_status': '有效',
  'expiring_status': '即將過期',
  'subscription_active': '您的年度訂閱已激活，自動續訂已開啟。',
  'auto_renewal_off': '您已關閉自動續訂。您仍可繼續使用所有功能直至訂閱到期。',
  'subscription_expiry_warning': '您的訂閱將於{endTime}到期。到期後，您將失去所有會員特權。',
  'restore_subscription': '恢復續訂',
  'subscription_period': '訂閱週期',
  'next_payment_date': '下次扣款日期',
  'next_payment_amount': '下次扣款金額',
  'subscription_status': '訂閱狀態',
  'auto_renewal_on': '自動續訂已開啟',
  'auto_renewal_off_status': '自動續訂已關閉',
  'expires_on': '有效期至 {expiryDate}',
  'card_expired': '已過期',
  'change': '更改',
  'card_expiry_warning': '您的支付卡已過期，為確保服務不中斷，請更新為有效的支付方式。這不會立即扣款，',
  'next_payment_notice': '僅在下次續費週期{nextPaymentDate}時使用。',
  'auto_renewal_status_on': '自動續訂已開啟',
  'auto_renewal_status_off': '自動續訂已關閉',
  'renewal_on_details': '自動續訂已開啟。您的會員資格將在{nextPaymentDate}自動續期，屆時將向您收取 {nextPaymentAmount}的年費',
  'renewal_off_details': '自動續訂已關閉。您的會員資格將在{endTime}到期，開啟自動續訂可繼續享受所有會員特權。',
  'upgrade_plan': '升級套餐',
  'current_benefits': '當前權益',
  'highest_version': '您當前已升至最高版本',
  'light': '淺色',
  'dark': '深色',
  'system': '跟隨系統',
  'alipay': '支付寶',
  // 積分管理
  'points_management': '積分管理',
  'total_points': '總積分',
  'subscription_points': '訂閱積分',
  'purchased_points': '增購積分',
  'activity_points': '活動積分',
  'buy_points_packages': '購買積分拓展包',
  'buy_now': '立即購買',
  'points_package': '積分包',
  'get_points_info_failed': '獲取積分信息失敗',
  'get_package_list_failed': '獲取拓展包列表失敗'
}
